import type { Creator, FishHabitat } from "./types";

export type ExploreFilters = {
  habitat: FishHabitat | "all";
  region: string;
  query: string;
};

export function uniqueRegions(creators: Creator[]): string[] {
  const set = new Set(creators.map((c) => c.region.trim()).filter(Boolean));
  return [...set].sort((a, b) => a.localeCompare(b));
}

export function filterCreators(
  creators: Creator[],
  f: ExploreFilters,
): Creator[] {
  const q = f.query.trim().toLowerCase();

  return creators.filter((c) => {
    if (f.habitat !== "all" && !c.habitats.includes(f.habitat)) {
      return false;
    }
    if (f.region !== "all" && c.region !== f.region) {
      return false;
    }
    if (q) {
      const hay = [
        c.displayName,
        c.bio,
        c.role,
        c.region,
        ...c.habitats,
      ]
        .join(" ")
        .toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}
